import React from 'react';
import { Toaster } from 'sonner';
import {
  Navigation,
  HeroSection,
  ProblemSection,
  SolutionSection,
  FeaturesSection,
  HowItWorksSection,
  UseCasesSection,
  PricingSection,
  SecuritySection,
  FinalCTASection,
  DemoForm,
  Footer,
} from '@/components/landing';

const LandingPage = () => {
  const scrollToDemo = () => {
    const demoSection = document.getElementById('demo-form');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSeeSimulation = () => {
    // For now, scroll to the how-it-works section
    const section = document.getElementById('how-it-works');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: '#1e293b',
            color: '#f1f5f9',
            border: '1px solid #334155',
          },
        }}
      />
      
      <Navigation onBookDemo={scrollToDemo} />
      
      <main>
        <HeroSection onBookDemo={scrollToDemo} onSeeSimulation={handleSeeSimulation} />
        <ProblemSection />
        <SolutionSection />
        <FeaturesSection />
        <HowItWorksSection />
        <UseCasesSection />
        <PricingSection onBookDemo={scrollToDemo} />
        <SecuritySection />
        <FinalCTASection onBookDemo={scrollToDemo} />
        <DemoForm id="demo-form" />
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
